import { initSelectForm } from './form.js';
import { initStageMenus } from './list.js';

export function initAssignRecipe() {
	initSelectForm();
	initStageMenus();
}
